export default __webpack_public_path__ + "static/media/webilo-services.36e78287.svg";